export default __webpack_public_path__ + "static/media/unit-result-header.ebdaa6d7.svg";